import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { reducerUpdateButtonTour } from 'src/features/productTour';

export default function BlackScreenComponent() {
  const dispatch = useAppDispatch();
  const { isTourButtonOpen } = useAppSelector(
    (state) => state.storeProductTour
  );

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        position: 'absolute',
        zIndex: 100,
        width: '100%',
        height: '100%',
        opacity: 0.5
      }}
      component="div"
      onClick={
        isTourButtonOpen
          ? () => dispatch(reducerUpdateButtonTour(false))
          : undefined
      }
    />
  );
}
